import { BookmarkIcon, MapPinIcon } from "@heroicons/react/24/solid";
import {
  Avatar,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Typography
  } from "@material-tailwind/react";
import { Link } from "react-router-dom";
   
export default function CardCommon({jobData}) {
  // console.log(jobData);

  return (
   
      <Card className="mt-6 w-full">
        <CardHeader
            color="transparent"
            floated={false}
            shadow={false}
            className="flex items-center gap-4"
          >
            <Avatar
              className='!static'
              size="lg"
              variant="square"
              src={jobData.company_image_url}
              alt="tania andrew"
            />
            <div className="flex w-full flex-col gap-0.5">
              <div className="flex items-center justify-between">
                <Typography color="blue-gray" className="text-2xl md:text-xl font-semibold">
                  {jobData.title}
                </Typography>
              </div>
              <Typography color="blue-gray">{jobData.company_name}</Typography>
            </div>
        </CardHeader>
        <CardBody className="space-y-2">
          <div className="flex ">
            <MapPinIcon className="w-6 text-gray-200 dark:text-gray-200"/>
            <Typography variant="small">{jobData.company_city}</Typography>
          </div>
          <div className="flex ">
            <MapPinIcon className="w-6 text-gray-200 dark:text-gray-200"/>
            <Typography variant="small">{jobData.job_type}</Typography>
          </div>
          <div className="flex ">
            <MapPinIcon className="w-6 text-gray-200 dark:text-gray-200"/>
            <Typography variant="small">{jobData.job_tenure}</Typography>
          </div>
        </CardBody>
        <CardFooter className="border-t-2 flex justify-between content-center">
          <Typography>{jobData.created_at}</Typography>
          <Link>
            <BookmarkIcon  className="w-6 text-gray-200 dark:text-gray-200 hover:text-black"/>
          </Link>
        </CardFooter>
      </Card>
  );
}